import React, { createContext, useCallback, useContext, useState } from 'react';

interface BookingGateContextValue {
  open: (bookingUrl: string) => void;
  isOpen: boolean;
  close: () => void;
  pendingUrl: string;
}

const BookingGateContext = createContext<BookingGateContextValue | null>(null);

export const BookingGateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [pendingUrl, setPendingUrl] = useState('');

  const open = useCallback((bookingUrl: string) => {
    setPendingUrl(bookingUrl);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <BookingGateContext.Provider value={{ open, isOpen, close, pendingUrl }}>
      {children}
    </BookingGateContext.Provider>
  );
};

export const useBookingGate = (): BookingGateContextValue => {
  const ctx = useContext(BookingGateContext);
  if (!ctx) throw new Error('useBookingGate must be used inside BookingGateProvider');
  return ctx;
};
